import { CodeListLog } from "../code-list-log.entity";
import { CodeListMain } from "../code-list-main.entity";
import { CodeListMainDTO } from "./code-list-main.dto";

export class CodeListLogAdapter {
    public convertDtoToEntity(entity: CodeListMain): CodeListLog[] {
        try {
            const codeListLogEntity: CodeListLog[] = []
            for (const item of entity.codeListItems) {
                const codeListLog = new CodeListLog;
                codeListLog.codeListMainId = entity.codeListMainId
                codeListLog.saleOrderId = entity.saleOrderId
                codeListLog.codeListMainItemId = item.codeListMainItemId
                codeListLog.soItemId = item.soItemId
                codeListLog.tracebilityCodeId = item.tracebilityCodeId
                codeListLog.code = item.code;
                codeListLog.cartons = item.cartons;
                codeListLog.productionDate = item.productionDate;
                codeListLog.bestBeforeDate = item.bestBeforeDate;
                codeListLog.unitId = item.unitId;
                codeListLog.createdAt = item.createdAt;
                codeListLog.createdUser = item.createdUser;
                codeListLogEntity.push(codeListLog)
            }
            return codeListLogEntity
        } catch (error) {
            return error
        }
    }


}